import { Component, ViewChild, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';

import { ListService } from '../../../services/list.service';

import { Repository } from '../../../services/repository';

import { Lists_danhmucchucvu } from '../../../routes/menu';



const swal = require('sweetalert');



@Component({

  selector: 'app-danhmuc-chucvuedit',

  templateUrl: './chucvuedit.component.html',

  styleUrls: ['./chucvuedit.component.scss'],

  providers: [ListService, Repository]

})

export class chucvueditComponent implements OnInit {

  @ViewChild('mafocus', { static: false }) mafocus: ElementRef;

  @Output() save: EventEmitter<any> = new EventEmitter();



  quyen_them = false;

  quyen_sua = false;

  quyen_xoa = false;

  bledit = false;

  phanHeId: string = Lists_danhmucchucvu.id;

  currentUser: any;

  inputParents: any[] = [];

  doituongSelect: any = this.emptyModel();



  public ngxCurrencyOptions = {

    prefix: '', thousands: '', decimal: ',', precision: 0, allowNegative: false

  };



  constructor(private _dataService: ListService, public repo: Repository) { }



  ngOnInit(): void { }



  emptyModel() {

    return {

      Id: null, Ma: null, Ten: null, TenTiengNuocNgoai: null, NhomId: null,

      SapXep: null, DoiTuongId: 0, ParentId: null,

      Created: null, CreatedBy: null, Modified: null, ModifiedBy: null

    };

  }



  loadDataInit(nhomdoituongid: string, id: any, donviid: string, khoahocid: number, tudanhsach: number, parentId?: number) {

    const authlogin = localStorage.getItem('currentUser');

    if (authlogin) {

      this.currentUser = JSON.parse(authlogin);

      const giatri = this.currentUser.ds_quyen.filter((name: any) => name.Id === Lists_danhmucchucvu.id.toLowerCase());

      if (giatri != null && giatri.length > 0) {

        this.quyen_them = !!giatri[0].Them;

        this.quyen_sua = !!giatri[0].Sua;

        this.quyen_xoa = !!giatri[0].Xoa;

      } else {

        this.quyen_them = this.quyen_sua = true;

      }

    }



    setTimeout(() => {

      if (this.mafocus) this.mafocus.nativeElement.focus();

    }, 300);



    this.doituongSelect = this.emptyModel();

    this.loadParents(id);



    if (id == null || id === '') {

      this.bledit = false;

      this.doituongSelect.Created = new Date();

      this.doituongSelect.Modified = new Date();

      if (parentId) this.doituongSelect.ParentId = parentId;

      if (this.currentUser) {

        this.doituongSelect.CreatedBy = this.currentUser.user_name;

        this.doituongSelect.ModifiedBy = this.currentUser.user_name;

      }

    } else {

      this.bledit = true;

      this.repo.getRequest('api/chucvu/getbyid/' + id).subscribe(response => {

        if (!response) return;

        this.doituongSelect.Id = response.Id != null ? response.Id : response.id;

        this.doituongSelect.Ma = response.Ma != null ? response.Ma : response.ma;

        this.doituongSelect.Ten = response.Ten != null ? response.Ten : response.ten;

        this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai != null ? response.TenTiengNuocNgoai : response.tenTiengNuocNgoai;

        this.doituongSelect.NhomId = response.NhomId != null ? response.NhomId : response.nhomId;

        this.doituongSelect.SapXep = response.SapXep != null ? response.SapXep : response.sapXep;

        this.doituongSelect.DoiTuongId = (response.DoiTuongId != null ? response.DoiTuongId : response.doiTuongId) != null

          ? (response.DoiTuongId != null ? response.DoiTuongId : response.doiTuongId) : 0;

        this.doituongSelect.ParentId = response.ParentId != null ? response.ParentId : response.parentId;

        this.doituongSelect.Created = response.Created != null ? new Date(response.Created)

          : (response.created != null ? new Date(response.created) : new Date());

        this.doituongSelect.CreatedBy = response.CreatedBy != null ? response.CreatedBy : response.createdBy;

        this.doituongSelect.Modified = new Date();

        this.doituongSelect.ModifiedBy = this.currentUser ? this.currentUser.user_name : null;

      });

    }

  }



  loadParents(excludeId: any) {

    this.repo.getRequest('api/chucvu/getall').subscribe(res => {

      const list = res || [];

      this.inputParents = list

        .filter((x: any) => {

          const xid = x.Id != null ? x.Id : x.id;

          return excludeId == null || excludeId === '' || xid !== excludeId;

        })

        .map((x: any) => ({

          Id: x.Id != null ? x.Id : x.id,

          Ten: ((x.Ma || x.ma) ? (x.Ma || x.ma) + ' — ' : '') + (x.Ten || x.ten || '')

        }));

    }, () => {

      this.repo.postRequest('api/chucvu/getall', {}).subscribe(res2 => {

        const list = res2 || [];

        this.inputParents = list.map((x: any) => ({

          Id: x.Id != null ? x.Id : x.id,

          Ten: ((x.Ma || x.ma) ? (x.Ma || x.ma) + ' — ' : '') + (x.Ten || x.ten || '')

        }));

      });

    });

  }



  closeModal() {

    this.save.emit(null);

  }



  saveproduct() {

    if (this.doituongSelect.Id == null) this.doituongSelect.Id = 0;

    if (!this.doituongSelect.Ten) {

      swal('Lỗi!', 'Vui lòng nhập tên chức vụ!', 'error');

      return;

    }

    if (this.doituongSelect.DoiTuongId == null) this.doituongSelect.DoiTuongId = 0;

    if (this.doituongSelect.ParentId === 0) this.doituongSelect.ParentId = null;



    this.repo.postRequest('api/chucvu/addorupdate', this.doituongSelect).subscribe(response => {

      if (response === 1 || response === '1' || (typeof response === 'number' && response > 0)) {

        this.save.emit(this.doituongSelect);

      } else if (response != null && response !== '') {

        swal('Cảnh báo!', response, 'warning');

      } else {

        this.save.emit(this.doituongSelect);

      }

    });

  }

}


